import { apiRequest } from '@/utils/api-request';

export interface FieldOverride {
  field_id: string;
  type?: string | null;
  current_value?: unknown;
  required?: boolean;
}

export interface InputNodeOverride {
  node_instance_id: string;
  node_type?: string | null;
  fields: FieldOverride[];
}

export interface TriggerRunRequest {
  session_id: string;
  version_id?: string | null;
  inputs?: InputNodeOverride[] | null;
  metadata?: Record<string, unknown> | null;
}

export interface TriggerRunResponse {
  run_id: string;
  session_id: string;
  status: string;
}

export async function asyncRunWorkflowVersion(
  orgId: string,
  workflowId: string,
  body: TriggerRunRequest,
): Promise<TriggerRunResponse> {
  const response = await apiRequest<TriggerRunResponse>({
    url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/async-run-workflow-version`,
    method: 'POST',
    target: 'workflow',
    body: body as unknown as Record<string, unknown>,
  });
  if (response.detail || response.success === false || !response.data) {
    throw new Error(response.detail || 'Failed to start workflow run');
  }
  return response.data;
}
